import type { RouteObject } from "react-router-dom";

import { Protected } from "@dzambalaorg/common-pages";
import {
  Kanban,
  Statistics,
  ProductPromo,
  Photo,
  Order,
  Parameter,
  Category,
  Product,
  ServiceType,
} from "@framework/shared";

export const ecommerceRoutes: Array<RouteObject> = [
  {
    path: "/products",
    element: <Protected />,
    children: [
      { index: true, element: <Product service={ServiceType.OFFICE} /> },
      { path: "/products/:id", element: <Product service={ServiceType.OFFICE} /> },
    ],
  },
  {
    path: "/categories",
    element: <Protected />,
    children: [
      { index: true, element: <Category service={ServiceType.OFFICE} /> },
      { path: "/categories/:id", element: <Category service={ServiceType.OFFICE} /> },
    ],
  },
  {
    path: "/parameters",
    element: <Protected />,
    children: [
      { index: true, element: <Parameter service={ServiceType.OFFICE} /> },
      { path: "/parameters/:id", element: <Parameter service={ServiceType.OFFICE} /> },
    ],
  },
  {
    path: "/promos",
    element: <Protected />,
    children: [
      { index: true, element: <ProductPromo service={ServiceType.OFFICE} /> },
      { path: "/promos/:id", element: <ProductPromo service={ServiceType.OFFICE} /> },
    ],
  },
  {
    path: "/kanban",
    element: <Protected />,
    children: [
      { index: true, element: <Kanban service={ServiceType.OFFICE} /> },
      { path: "/kanban/:id", element: <Kanban service={ServiceType.OFFICE} /> },
    ],
  },
  {
    path: "/orders",
    element: <Protected />,
    children: [
      { index: true, element: <Order service={ServiceType.OFFICE} /> },
      { path: "/orders/:id", element: <Order service={ServiceType.OFFICE} /> },
    ],
  },
  {
    path: "/photos",
    element: <Protected />,
    children: [{ index: true, element: <Photo service={ServiceType.OFFICE} /> }],
  },
  {
    path: "/statistics",
    element: <Protected />,
    children: [{ index: true, element: <Statistics /> }],
  },
];
